import React from 'react';
import { LoaderWrapper, Loader, StyledTextStatus } from './StyledComponents';
import i18n from 'i18n';

export const GlobalLoader = ({ cleanBackground, isNetworkLoader }) => (
  <LoaderWrapper cleanBackground={cleanBackground} isNetworkLoader={isNetworkLoader}>
    <Loader />
    {isNetworkLoader && <StyledTextStatus>{i18n.t('common.checkingNetwork')}</StyledTextStatus>}
  </LoaderWrapper>
);

export const LoaderComponent = () => <Loader />;

export default GlobalLoader;
